import { HintName } from 'mk2/apps/users/containers/Hints/Hints.constants';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { Action } from 'redux';

/////////////////////////////////////////////////////////////////////
// Close hint (for example on group subscribed feed)

export interface HintsCloseHintApiAction extends Action {
    name: HintName;
}

export const HINTS_CLOSE_HINT_API_REQUEST = 'HINTS_CLOSE_HINT_API_REQUEST';

export interface HintsCloseHintRequestAction extends HintsCloseHintApiAction, APIRequestAction {
    readonly type: typeof HINTS_CLOSE_HINT_API_REQUEST;
}

export const HINTS_CLOSE_HINT_API_SUCCESS = 'HINTS_CLOSE_HINT_API_SUCCESS';

export interface HintsCloseHintSuccessAction extends HintsCloseHintApiAction, APISuccessAction {
    readonly type: typeof HINTS_CLOSE_HINT_API_SUCCESS;
}

export const HINTS_CLOSE_HINT_API_FAILURE = 'HINTS_CLOSE_HINT_API_FAILURE';

export interface HintsCloseHintFailureAction extends HintsCloseHintApiAction, APIFailureAction {
    readonly type: typeof HINTS_CLOSE_HINT_API_FAILURE;
}

export const hintsCloseHintApi = {
    request: (name: HintName): HintsCloseHintRequestAction => ({ type: HINTS_CLOSE_HINT_API_REQUEST, name }),
    success: (name: HintName, response: any): HintsCloseHintSuccessAction => ({ type: HINTS_CLOSE_HINT_API_SUCCESS, name, response }),
    failure: (name: HintName, error: any): HintsCloseHintFailureAction => ({ type: HINTS_CLOSE_HINT_API_FAILURE, name, error }),
};

export const HINTS_CLOSE_HINT = 'HINTS_CLOSE_HINT';

export interface HintsCloseHintAction extends HintsCloseHintApiAction {
    readonly type: typeof HINTS_CLOSE_HINT;
}

export const hintsCloseHint = (name: HintName): HintsCloseHintAction => ({
    type: HINTS_CLOSE_HINT, name,
});
